import { z } from 'zod';

const MAX_FILE_SIZE = 10 * 1024 * 1024; // 10MB
const ALLOWED_FILE_TYPES = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif', 'image/svg+xml'];

export const AddCustomerSchema = z.object({
    notes: z.string().optional(),
    status: z.string().min(1, 'status is required'),
    // branch: z.string().min(1, 'branch is required'),
    from: z.string().min(1, 'from is required'),
    service_id: z.string().min(1, 'service_id is required'),
    customer_id: z.string().min(1, 'customer_id is required'),
    paid: z.coerce.number().optional().default(0).refine((val) => val >= 0, 'paid must be greater than or equal to 0'),
});

export type AddCustomerFormValues = z.infer<typeof AddCustomerSchema>;
